







import { Filter } from "@/utils/decorator";
import moment from "moment";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CustomTimeLabel extends Vue {
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "" }) value?: string;

  @Filter()
  dateFormat(date: Date) {
    return moment(date).format("yyyy-MM-DD HH:mm");
  }
}
